import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const CaseClosureApprovals = lazy(() => import('./CaseClosureApprovals.jsx'))
const CaseDetails = lazy(() => import('./CaseDetails.jsx'))

const CaseClosureApprovalsRoutes = [
  {
    path: '/case-closure-approvals',
    component: CaseClosureApprovals,
    auth: authRoleAccess.case_closure_approvals, 
  },
  {
    path: '/case-closure-approvals/case/:id',
    component: CaseDetails,
    auth: authRoleAccess.case_closure_approvals, 
  },
]

export default CaseClosureApprovalsRoutes
